import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Container } from 'react-bootstrap';
import './Intake.css'; // Reusing the same styles

function Intake() {
  return (
    <Container>
      <Row>
        <Col>
          <h1 className="home-title">Fast Track Intake Form</h1>
          <p className="home-description">
            The PA Permit Fast Track Program streamlines permitting for high-impact economic development and 
            infrastructure projects in Pennsylvania that require multiple permits from different Commonwealth 
            agencies. The Office of Transformation & Opportunity provides inter-agency coordination and 
            transparency for project sponsors and the public alike.
          </p>
          <p className="home-description">
            Visit our <Link to="/">Program</Link> page to learn more.
          </p>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="d-flex justify-content-center">
          <div className="embed-container">
            <iframe
              src="https://forms.monday.com/forms/embed/5b5cbaa33d7add00965633a77d237966?r=use1"
              title="Fast Track Intake Form"
              allowTransparency="true"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Intake; 